import Skeleton from '@mui/material/Skeleton';
import PropTypes from 'prop-types';
import React from 'react';

const InputTextSkeleton = ({ label, required }) => (
  <div>
    {label && (
      <label className="input-text__label">
        {label} {required && <sup>*</sup>}
      </label>
    )}

    <Skeleton animation="wave" height={48} variant="text" />
  </div>
);

InputTextSkeleton.propTypes = {
  label: PropTypes.node,
  required: PropTypes.bool,
};

export default InputTextSkeleton;
